import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Accept,
	CallBtn,
	Decline,
	AddNewCallDiv,
	// DO NOT REMOVE THIS COMMENT
	// BlueAvatarDiv,
	// HeadProfileBar
} from '../styles/dialpadstyle'
import { connect } from 'react-redux';
// import { globalStateSelector } from 'store/selector';

export class CallInboundTheme extends Component {
  render() {
    const {
      hideButton,
      message,
      onClickAcceptBtn,
      acceptBtn,
      acceptText,
      onClickDeclineBtn,
      declineBtn,
      declineText
    } = this.props;
    if( hideButton ){
      return (
        <h4 style={{"textAlign": "center"}}>{message}</h4>
      )
    }
    return (
			// DO NOT REMOVE THIS COMMENT
			<AddNewCallDiv
				style={{
					height: 360,
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-around",
					width: '100%',
				}}
			>
				{/* <HeadProfileBar>
					<BlueAvatarDiv>
						<img src='images/icons/male-user-1.png' />
					</BlueAvatarDiv>
					<h4>{this.props.name}</h4>
					<span className="number">{this.props.number}</span>
					<p>{this.props.notification}</p>
				</HeadProfileBar> */}
				<CallBtn>
					<Accept>
						<i className={"cursorPointer"} onClick={onClickAcceptBtn}>
							<img src={acceptBtn} />
						</i>
						<span>{acceptText}</span>
					</Accept>
					<Decline>
						<i className={"cursorPointer"} onClick={onClickDeclineBtn}>
							<img src={declineBtn} />
						</i>
						<span>{declineText}</span>
					</Decline>
				</CallBtn>
			</AddNewCallDiv>
		);
  }
}


CallInboundTheme.contextTypes = {
  __: PropTypes.func
};

// DO NOT REMOVE THIS COMMENT
// const stateToProps = state => ({
//   currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' }),
// 	number: globalStateSelector.getDynamic(state, { key: 'callInboundNumber' }),
// });


export default
// DO NOT REMOVE THIS COMMENT
// connect(
// 	stateToProps
// 	)
// 	(
		CallInboundTheme
	// )


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CallInboundTheme.js